import React, { useState, useContext, useEffect } from 'react';
import MaterialTable from 'material-table'
import PatchedPagination from './PatchedPagination';
import { serverContext, appContext, putToServer } from '../App';
import { useServerGet } from '../customEffects';
import SelectUsergroups from './SelectUsergroups'
import { tableIcons } from '../commonTypes';
import { useTableTheming } from './useTableTheming';


const PlatformInfoTable = props => {

  const { server } = useContext(serverContext);
  const { dispatchApp } = useContext(appContext);
  const [selectedRow, setSelectedRow] = useState(null);
  const tableTheme = useTableTheming(selectedRow);
  const [data, setData] = useState([]);
  const [updated, setUpdated] = useState(Date.now());
  const { data: platforms} = useServerGet('platforms', server, updated);

  useEffect(() => {
    if (platforms) {
      const pl = platforms.map(p => {

        return {
          name: p.name,
          description: p.description,
          selectedUserGroups: p.usergroups ? p.usergroups : [],
          usergroups: p.usergroups ? p.usergroups.map(u => u.name).toString() : 'All'
        }
      });

      setData(pl);
    }
  }, [platforms])


  const columns = [
    { title: 'Name', field: 'name', tooltip: 'Platform name', editable: 'never', width: '20%' },
    { title: 'Description', field: 'description', tooltip: 'Platform description', editable: 'never', width: '25%' },
    {
      title: 'Usergroup', field: 'usergroups',
      editComponent: props => (
        <SelectUsergroups canDeleteDemo selectedUserGroups={props.rowData.selectedUserGroups} onUserGroupsChange={ug => handleUserGroupsChange(props.rowData.name, ug)} />
      )
    }
  ];



  const handleUserGroupsChange = async (name, ugs) => {

    console.log("handleUserGroupsChange")
    const dataUpdate = [...data];
    const pl = dataUpdate.find(d => d.name === name);
    pl.selectedUserGroups = ugs;
    setData([...dataUpdate]);
    if (server.serverHost) {

    try {
      const ids = ugs.map(g => g._id);

      await putToServer(`platforms/usergroups/${name}?ids=${ids.toString()}&createIfNotExists`, {}, server);
      setUpdated(Date.now());
    } catch (error) {

        dispatchApp({ type: 'SHOW_ALERT', payload: { title: 'Error', message: `Error updating usergroups for ${name} : ${error.response.data}` } });
      }
    }
  }




  return (
    <MaterialTable
      icons={tableIcons}
      columns={columns}
      data={data}
      title={props.title || '✈︎ Platform Info'}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow))}
      options={{
        selection: false,
        cellStyle: tableTheme.cellStyle,
        headerStyle: tableTheme.headerStyle,
        filterRowStyle: tableTheme.filterRowStyle,
        rowStyle: tableTheme.rowStyle,
      }}
      editable={{
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            resolve();
          }),
      }}
      components={{
        Pagination: PatchedPagination,
      }}
    />
  );
}



export default PlatformInfoTable; 
